import React, { useEffect, useState } from "react";
import { getAttendanceDetails } from "_controllers/officer";
import { DateTime } from "luxon";
import { useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import "./Attendance.css"
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Box } from "@mui/system";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";

const Attendance = () => {
  const { SAP_ID } = useParams();

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const fileName = `${SAP_ID}-attendence-report`;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dealers, setDealers] = useState([]);
  const [message, setMessage] = useState("");
  const [csvData, setCsvData] = useState([]);

  useEffect(async () => {
    // if (!planDate || !SAP_ID) return;

    // const today = DateTime.now();

    // const startDate =
    //   today.day > 27
    //     ? today.plus({ months: 1 }).startOf("month")
    //     : today.startOf("month");

    // const endDate = startDate.endOf("month");

    // setStartDate({
    //   year: startDate.year,
    //   month: startDate.month,
    //   day: startDate.day,
    // });
    // setEndDate({
    //   year: endDate.year,
    //   month: endDate.month,
    //   day: endDate.day,
    // });
    const startDate = moment().startOf("month").format("YYYY-MM-DD");

    const endDate = moment().endOf("month").format("YYYY-MM-DD");

    const plan = await getAttendanceDetails({
      SAP_ID,
      startDate,
      endDate,
    });
    console.log("ji", plan?.data);
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }, [message]);

  const timeSpent = (a, b) => {
    const test = moment.duration(moment(b ? b : "").diff(moment(a ? a : "")))
    return `${test.asMinutes().toFixed(0)} mins`
  };

  const { selectStartDate, selectEndDate } = Values

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log("lp", Values)
    const plan = await getAttendanceDetails({
      SAP_ID,
      startDate: selectStartDate,
      endDate: selectEndDate,
    });
    console.log("kop", plan?.data);
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(csvData.map(x => ({
      'SAP ID': x?.data?.SAP_ID,
      'Date': x._id.date,
      // 'Time Spent(mins)': x.total_count
    })), fileName)
  }

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <form onSubmit={handleSubmit}>
          <Grid container xs={12} sx={{ m: 1 }}>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>Start Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectStartDate}
                  name="selectStartDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Grid item xs={3}>
                <h5>End Date :</h5>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  type={'date'}
                  sx={{ width: '80%' }}
                  onChange={handleChange}
                  value={selectEndDate}
                  name="selectEndDate"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
              <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
            </Grid>
          </Grid>
        </form>
      </Box>
      {loading ? (
        <>
          <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Date</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Dealer's Visit</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Dealer Code</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Login Time</TableCell>
                  <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Logout Time</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Time Spent</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length > 0
                  ? data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?._id?.date}</TableCell>
                      <TableCell align="center">{d?.data.length}</TableCell>
                      <TableCell align="left">
                        {d?.data.length > 0
                          ? d?.data.map((dealer) => {
                            return <div className="tooltip" style={{ cursor: 'pointer' }}>{dealer?.dealerCode},
                              <span className="tooltiptext">{dealer?.dealer?.name}</span>
                            </div>;
                          })
                          : "No Visit Today"}
                      </TableCell>
                      {/* <TableCell>
                        {d?.data.length > 0
                          ? d?.data[d.data.length - 1].completed
                            ? "Completed"
                            : "Pending"
                          : null}
                      </TableCell> */}
                      <TableCell
                        style={{ cursor: "pointer" }}
                      >
                        {d?.data.length > 0
                          ?
                          d?.data[0].startTime ? moment(d?.data[0].startTime).subtract(330, 'minutes').format("hh:mm A") : "-"
                          : null}
                      </TableCell>
                      <TableCell
                        style={{ cursor: "pointer" }}
                      >
                        {d?.data.length > 0
                          ?
                          d?.data[d.data.length - 1].endTime ? moment(d?.data[d.data.length - 1].endTime).subtract(330, 'minutes').format("hh:mm A") : "-"
                          : null}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ cursor: "pointer" }}
                      >
                        {d?.data.length > 0
                          ? (timeSpent(
                            d?.data[0].startTime,
                            d?.data[d.data.length - 1].endTime
                          ))
                          : null}
                      </TableCell>
                    </TableRow>
                  ))
                  : <Box sx={{ textAlign: 'left', pt: 1 }}>
                    <Typography variant="h6" sx={{ p: 1 }}>No Visit Attendance Available For This Month.</Typography>
                  </Box>}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default Attendance;
